import { CurrencyCode, Localisation, RegionVariant, TimeFormat } from 'app/model/enums/region-variant';
import { regionVariantAustralia } from './regions/region-variant-australia';
import { regionVariantUK } from './regions/region-variant-uk';

export interface RegionVariantDetails {
  text: {
    general: {
      tax_code: {
        title_case: string;
        sentence_case: string;
      };
      grid_headers: {
        value_dollars: string;
        actual_dollars: string;
        total_dollars: string;
        capacity_dollars: string;
        chargeable_dollars: string;
        nonchargeable_dollars: string;
        fees: string;
        tax: string;
        job_type: string;
      };
      filters: {
        job_type: {
          label_selected: string;
          label_unselected: string;
        };
      };
    };
    settings: {
      positions: {
        title: string;
        subtitle: string;
        icon: string;
      };
    };
    time_entry: {
      header_date_format: string;
      rate: string;
    };
    disbursements: {
      grid_headers: {
        amount_ex_tax: string;
        billed_ex_tax: string;
      };
      drawer: {
        amount: string;
        tax: string;
        total: string;
        amount_short: string;
        tax_short: string;
        total_short: string;
      };
    };
    time_vs_billed: {
      grid_headers: {
        posted_total: string;
        unposted_total: string;
        billed_total: string;
        total: string;
        posted_hours: string;
        unposted_hours: string;
        hours: string;
      };
    };
    job_activity: {
      grid_headers: {
        dollars_per_hour_ex_tax: string;
      };
    };
    job_type_filters: {
      billing: boolean;
      setup_approvals: boolean;
    };
    invoice: {
      tax: string;
      taxInvoice: string;
      taxInvoiceDetails: string;
      nominalTaxCredit: string;
    };
  };
  show: {
    disbursements: {
      timeUnits: boolean;
      grid_columns: {
        taxCode: boolean;
      };
    };
    invoices: {
      nominalInvoices: boolean;
      creditNotes: boolean;
      billDetailLimits: boolean;
      disbursementApprovals: boolean;
      output_fields: {
        abn: boolean;
      };
    };
    reports: {
      sip9: boolean;
      text_enter_filter_criteria: boolean;
    };
    addMenu: {
      addJob: boolean;
      addUser: boolean;
    };
    timeCategoryDefaults: boolean;
    companySearch: boolean;
  };
  timeFormattingForceHours?: {
    timeReview: boolean;
    reports: boolean;
    invoices: boolean;
  };
  flag: {
    time_entry: {
      notes_required: boolean;
    };
  };
  defaultCurrencyCode: CurrencyCode;
  defaultLocalisation: Localisation; // TODO: this should be e.g. en-GB
  defaultTimeEntryMethod: 'decimal' | 'minutes' | 'conventional'; // TODO: Make this an enum
  disbursementCodesRequiresNoApproval: string[];
  disbursementCodesRequiresApproval: string[];
  timeFormat: TimeFormat;
  regionTax: string;
}

export const defaultRegionVariant: RegionVariant = RegionVariant.Australia;

export const regionVariants: Record<RegionVariant, RegionVariantDetails> = {
  Australia: regionVariantAustralia,
  UK: regionVariantUK,
};
